import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Dialog overlay variant — the backdrop behind the dialog content.
 */
const dialogOverlayVariants = cva('fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4 overflow-y-auto');

/**
 * Dialog content variant — the centered panel.
 *
 * ### Sizes
 * | size   | max-width | usage            |
 * |--------|-----------|------------------|
 * | `sm`   | 420px     | Auth forms       |
 * | `md`   | 540px     | General dialogs  |
 */
const dialogContentVariants = cva('relative w-full my-8 bg-surface rounded-card shadow-card', {
  variants: {
    size: {
      sm: 'max-w-[420px] p-6 lg:max-w-[480px] lg:p-8',
      md: 'max-w-[540px] p-6 lg:p-8',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export type DialogContentProps = VariantProps<typeof dialogContentVariants>;

export { dialogOverlayVariants, dialogContentVariants };
